// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { listModelStatusesRequestToJson, listModelStatusesResponseFromJson, listVendorStatusesRequestToJson, listVendorStatusesResponseFromJson, setModelStatusRequestToJson, setModelStatusResponseFromJson, setVendorStatusRequestToJson, setVendorStatusResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function listVendorStatuses(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AdminService/ListVendorStatuses', listVendorStatusesRequestToJson(request));
    return listVendorStatusesResponseFromJson(raw);
}
export function listVendorStatuses$(request, options) {
    return defer(() => listVendorStatusesWithTransport$(getGlobalTransport(), request, options));
}
export function listVendorStatusesWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AdminService/ListVendorStatuses', listVendorStatusesRequestToJson(request), options)
        .pipe(map(resp => listVendorStatusesResponseFromJson(resp)));
}
export async function setVendorStatus(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AdminService/SetVendorStatus', setVendorStatusRequestToJson(request));
    return setVendorStatusResponseFromJson(raw);
}
export function setVendorStatus$(request, options) {
    return defer(() => setVendorStatusWithTransport$(getGlobalTransport(), request, options));
}
export function setVendorStatusWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AdminService/SetVendorStatus', setVendorStatusRequestToJson(request), options)
        .pipe(map(resp => setVendorStatusResponseFromJson(resp)));
}
export async function listModelStatuses(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AdminService/ListModelStatuses', listModelStatusesRequestToJson(request));
    return listModelStatusesResponseFromJson(raw);
}
export function listModelStatuses$(request, options) {
    return defer(() => listModelStatusesWithTransport$(getGlobalTransport(), request, options));
}
export function listModelStatusesWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AdminService/ListModelStatuses', listModelStatusesRequestToJson(request), options)
        .pipe(map(resp => listModelStatusesResponseFromJson(resp)));
}
export async function setModelStatus(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AdminService/SetModelStatus', setModelStatusRequestToJson(request));
    return setModelStatusResponseFromJson(raw);
}
export function setModelStatus$(request, options) {
    return defer(() => setModelStatusWithTransport$(getGlobalTransport(), request, options));
}
export function setModelStatusWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AdminService/SetModelStatus', setModelStatusRequestToJson(request), options)
        .pipe(map(resp => setModelStatusResponseFromJson(resp)));
}
